var _defs, _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBlank({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a_ChatBlank{fill:#a3a3a3;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a_ChatBlank",
    d: "M19,1A18,18,0,0,1,37,19V35.8A1.2,1.2,0,0,1,35.8,37H19A18,18,0,1,1,19,1Zm0,33.6H34.6V19A15.6,15.6,0,1,0,19,34.6Z",
    transform: "translate(-1 -1)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a_ChatBlank",
    cx: 2.4,
    cy: 2.4,
    r: 2.4,
    transform: "translate(15.6 15.6)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a_ChatBlank",
    cx: 2.4,
    cy: 2.4,
    r: 2.4,
    transform: "translate(8.4 15.6)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "a_ChatBlank",
    cx: 2.4,
    cy: 2.4,
    r: 2.4,
    transform: "translate(22.8 15.6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBlank);
export default __webpack_public_path__ + "static/media/chat_blank.10c83e8ec406356744940ac130234030.svg";
export { ForwardRef as ReactComponent };